<div class="container box">
  <div class="page-wrapper">

    <section *ngIf="currentStep === 1" class="wizard-step-content">
      <div class="order-summary-card">
        <div class="order-summary-grid">
          <div class="summary-block">
            <h3 class="summary-title">Detalle de pedido:</h3>

            <div class="summary-item">
              <span class="summary-label">Obra:</span>
              <p class="summary-value">{{order.workName}}</p>
            </div>

            <div class="summary-item">
              <h4 class="summary-subtitle">Datos de receptor:</h4>
              <div class="summary-row">
                <span class="summary-label">N° de guía</span>
                <span class="summary-value">{{ order.folioNumberGD }}</span>
              </div>
            </div>
          </div>

          <div class="summary-block">
            <h3 class="summary-title">Datos de entrega:</h3>

            <div class="summary-row">
              <span class="summary-label">N° entrega</span>
              <span class="summary-value">{{ order.orderNumber }}</span>
            </div>

            <div class="summary-row">
              <span class="summary-label">Producto</span>
              <span class="summary-value">{{ order.productDescription }}</span>
            </div>

            <div class="summary-row">
              <span class="summary-label">Volumen</span>
              <span class="summary-value">{{ order.actualQuantityShipped }} {{order.um}}</span>
            </div>
          </div>

          <div class="summary-block summary-commets">
            <h3 class="summary-title">Comentarios:</h3>

            <div class="comment-box">
              {{ operatorCommentsText }}
            </div>

            <button type="button" class="link-button">
              <app-pedidos-pendiente-visualizarguia
                #visorGuia
                [rutaPdf]="order.routePdfGuide"
                [tkt]="order.tkt.toString()"
                [hide]="true"
                [isOnlyIcon]="false">
              </app-pedidos-pendiente-visualizarguia>

              <span class="clickable ver-guia" (click)="visorGuia.onOpenModal()">
                <i class="bi bi-eye me-1"></i>Ver guía
              </span>
            </button>
          </div>
        </div>
      </div>

      <section class="secction-box">
        <h2 class="section-title">Estado del camión</h2>

        <section class="truck-status-section estado-section section-principal">
          <p class="help-text">
            Puedes marcar el estado del camión en caso de que no se actualice automáticamente.
          </p>

          <div class="truck-status-inline">
<div class="status-row">

  <!-- ✅ COMPLETADO (status >= 6): todo activo, SIN CLICK -->
<ng-container *ngIf="isCompletedStatus; else editableStatus">
  <div class="status-item" *ngFor="let status of statuses; let i = index">

    <!-- ✅ SOLO VISUAL: punto pintado -->
    <div class="status-dot status-dot--done"></div>

    <div class="status-bottom">
      <div class="status-pill" [ngClass]="[
        'status-pill--active',
        i === 0 ? 'status-pill--cargando' : '',
        i === 1 ? 'status-pill--enruta' : '',
        i === 2 ? 'status-pill--enobra' : '',
        i === 3 ? 'status-pill--findescarga' : ''
      ]">
        <span class="status-pill-icon">
          <ng-container [ngSwitch]="i">
            <span *ngSwitchCase="0"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.66667 0C2.98667 0 0 2.98667 0 6.66667C0 10.3467 2.98667 13.3333 6.66667 13.3333C10.3467 13.3333 13.3333 10.3467 13.3333 6.66667C13.3333 2.98667 10.3467 0 6.66667 0ZM6.66667 12C3.72667 12 1.33333 9.60667 1.33333 6.66667C1.33333 3.72667 3.72667 1.33333 6.66667 1.33333C9.60667 1.33333 12 3.72667 12 6.66667C12 9.60667 9.60667 12 6.66667 12ZM9.72667 3.72L5.33333 8.11333L3.60667 6.39333L2.66667 7.33333L5.33333 10L10.6667 4.66667L9.72667 3.72Z" fill="#BF6C0B"/></svg></span>
            <span *ngSwitchCase="1"><svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.92 4.12L15.6067 2.22666C15.3933 0.933331 14.2867 0 12.9733 0H10C9.63333 0 9.33333 0.3 9.33333 0.666667V6H0.666667C0.3 6 0 6.3 0 6.66667V8.66667C0 9.28667 0.286667 9.82667 0.726667 10.1933C0.686667 10.3467 0.666667 10.5 0.666667 10.6667C0.666667 11.7667 1.56667 12.6667 2.66667 12.6667C3.36 12.6667 3.97333 12.3067 4.33333 11.7667C4.69333 12.3067 5.30667 12.6667 6 12.6667C7.1 12.6667 8 11.7667 8 10.6667H10.6667C10.6667 11.7667 11.5667 12.6667 12.6667 12.6667C13.7667 12.6667 14.6667 11.7667 14.6667 10.6667C14.6667 10.6267 14.66 10.5867 14.6533 10.5467C15.4333 10.2733 16 9.54 16 8.66667V5.10667C16 4.77334 15.9733 4.44666 15.92 4.12ZM2.66667 11.3333C2.3 11.3333 2 11.0333 2 10.6667C2 10.3 2.3 10 2.66667 10C3.03333 10 3.33333 10.3 3.33333 10.6667C3.33333 11.0333 3.03333 11.3333 2.66667 11.3333ZM6 11.3333C5.63333 11.3333 5.33333 11.0333 5.33333 10.6667C5.33333 10.3 5.63333 10 6 10C6.36667 10 6.66667 10.3 6.66667 10.6667C6.66667 11.0333 6.36667 11.3333 6 11.3333ZM9.33333 9.33333H7.48C7.11333 8.92667 6.58667 8.66667 6 8.66667C5.30667 8.66667 4.69333 9.02667 4.33333 9.56667C3.97333 9.02667 3.36 8.66667 2.66667 8.66667C2.22 8.66667 1.81333 8.82 1.48 9.06667C1.39333 8.95334 1.33333 8.82 1.33333 8.66667V7.33333H9.33333V9.33333ZM14.2867 2.44668L14.6 4.34001C14.62 4.44667 14.6133 4.56 14.6267 4.66667H13.9933C13.6267 4.66667 13.3267 4.36667 13.3267 4V1.38666C13.8133 1.52666 14.1933 1.92668 14.28 2.44668H14.2867ZM12.6667 11.3333C12.3 11.3333 12 11.0333 12 10.6667C12 10.3 12.3 10 12.6667 10C13.0333 10 13.3333 10.3 13.3333 10.6667C13.3333 11.0333 13.0333 11.3333 12.6667 11.3333ZM14.1267 9.30666C13.76 8.91333 13.2467 8.66667 12.6667 8.66667C12.0867 8.66667 11.5533 8.92667 11.1867 9.33333H10.6667V1.33333H12V4C12 5.1 12.9 6 14 6H14.6667V8.66667C14.6667 8.98667 14.4333 9.24666 14.1267 9.30666Z" fill="#1945BF"/></svg></span>
            <span *ngSwitchCase="2"><svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3.56667V10.6667H10.6667V5.33333H2.66667V10.6667H1.33333V3.56667L6.66667 1.43333L12 3.56667ZM13.3333 12V2.66667L6.66667 0L0 2.66667V12H4V6.66667H9.33333V12H13.3333ZM6 10.6667H4.66667V12H6V10.6667ZM7.33333 8.66667H6V10H7.33333V8.66667ZM8.66667 10.6667H7.33333V12H8.66667V10.6667Z" fill="#007EA0"/></svg></span>
            <span *ngSwitchCase="3"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V1.33333C12 0.6 11.4 0 10.6667 0ZM10.6667 10.6667H1.33333V1.33333H10.6667V10.6667ZM9.99333 4L9.05333 3.05333L4.66 7.44667L2.94 5.73333L1.99333 6.67333L4.66 9.33333L9.99333 4Z" fill="#05803D"/></svg></span>
          </ng-container>
        </span>
      </div>

      <span class="status-text status-text--active">{{ status }}</span>
      <span *ngIf="i < statuses.length - 1" class="status-line status-line--done"></span>
    </div>
  </div>
</ng-container>

  <!-- ✅ EDITABLE: permite click secuencial -->
  <ng-template #editableStatus>
    <div class="status-item" *ngFor="let status of statuses; let i = index">

<label
  class="status-radio-wrapper"
  [class.is-done]="i < currentStatusIndex"
  [class.is-current]="i === currentStatusIndex"
  (click)="onStatusClick(i, $event)"
>
  <input
    type="radio"
    name="truckStatus"
    [value]="i"
    [checked]="currentStatusIndex === i"
  />
  <span class="custom-radio"></span>
</label>





      <div class="status-bottom">
        <div class="status-pill" [ngClass]="[
          i <= visualStatusIndex ? 'status-pill--active' : '',
          i === 0 ? 'status-pill--cargando' : '',
          i === 1 ? 'status-pill--enruta' : '',
          i === 2 ? 'status-pill--enobra' : '',
          i === 3 ? 'status-pill--findescarga' : ''
        ]">
          <span class="status-pill-icon">
            <ng-container [ngSwitch]="i">
              <span *ngSwitchCase="0"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.66667 0C2.98667 0 0 2.98667 0 6.66667C0 10.3467 2.98667 13.3333 6.66667 13.3333C10.3467 13.3333 13.3333 10.3467 13.3333 6.66667C13.3333 2.98667 10.3467 0 6.66667 0ZM6.66667 12C3.72667 12 1.33333 9.60667 1.33333 6.66667C1.33333 3.72667 3.72667 1.33333 6.66667 1.33333C9.60667 1.33333 12 3.72667 12 6.66667C12 9.60667 9.60667 12 6.66667 12ZM9.72667 3.72L5.33333 8.11333L3.60667 6.39333L2.66667 7.33333L5.33333 10L10.6667 4.66667L9.72667 3.72Z" fill="#BF6C0B"/></svg></span>
              <span *ngSwitchCase="1"><svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.92 4.12L15.6067 2.22666C15.3933 0.933331 14.2867 0 12.9733 0H10C9.63333 0 9.33333 0.3 9.33333 0.666667V6H0.666667C0.3 6 0 6.3 0 6.66667V8.66667C0 9.28667 0.286667 9.82667 0.726667 10.1933C0.686667 10.3467 0.666667 10.5 0.666667 10.6667C0.666667 11.7667 1.56667 12.6667 2.66667 12.6667C3.36 12.6667 3.97333 12.3067 4.33333 11.7667C4.69333 12.3067 5.30667 12.6667 6 12.6667C7.1 12.6667 8 11.7667 8 10.6667H10.6667C10.6667 11.7667 11.5667 12.6667 12.6667 12.6667C13.7667 12.6667 14.6667 11.7667 14.6667 10.6667C14.6667 10.6267 14.66 10.5867 14.6533 10.5467C15.4333 10.2733 16 9.54 16 8.66667V5.10667C16 4.77334 15.9733 4.44666 15.92 4.12ZM2.66667 11.3333C2.3 11.3333 2 11.0333 2 10.6667C2 10.3 2.3 10 2.66667 10C3.03333 10 3.33333 10.3 3.33333 10.6667C3.33333 11.0333 3.03333 11.3333 2.66667 11.3333ZM6 11.3333C5.63333 11.3333 5.33333 11.0333 5.33333 10.6667C5.33333 10.3 5.63333 10 6 10C6.36667 10 6.66667 10.3 6.66667 10.6667C6.66667 11.0333 6.36667 11.3333 6 11.3333ZM9.33333 9.33333H7.48C7.11333 8.92667 6.58667 8.66667 6 8.66667C5.30667 8.66667 4.69333 9.02667 4.33333 9.56667C3.97333 9.02667 3.36 8.66667 2.66667 8.66667C2.22 8.66667 1.81333 8.82 1.48 9.06667C1.39333 8.95334 1.33333 8.82 1.33333 8.66667V7.33333H9.33333V9.33333ZM14.2867 2.44668L14.6 4.34001C14.62 4.44667 14.6133 4.56 14.6267 4.66667H13.9933C13.6267 4.66667 13.3267 4.36667 13.3267 4V1.38666C13.8133 1.52666 14.1933 1.92668 14.28 2.44668H14.2867ZM12.6667 11.3333C12.3 11.3333 12 11.0333 12 10.6667C12 10.3 12.3 10 12.6667 10C13.0333 10 13.3333 10.3 13.3333 10.6667C13.3333 11.0333 13.0333 11.3333 12.6667 11.3333ZM14.1267 9.30666C13.76 8.91333 13.2467 8.66667 12.6667 8.66667C12.0867 8.66667 11.5533 8.92667 11.1867 9.33333H10.6667V1.33333H12V4C12 5.1 12.9 6 14 6H14.6667V8.66667C14.6667 8.98667 14.4333 9.24666 14.1267 9.30666Z" fill="#1945BF"/></svg></span>
              <span *ngSwitchCase="2"><svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3.56667V10.6667H10.6667V5.33333H2.66667V10.6667H1.33333V3.56667L6.66667 1.43333L12 3.56667ZM13.3333 12V2.66667L6.66667 0L0 2.66667V12H4V6.66667H9.33333V12H13.3333ZM6 10.6667H4.66667V12H6V10.6667ZM7.33333 8.66667H6V10H7.33333V8.66667ZM8.66667 10.6667H7.33333V12H8.66667V10.6667Z" fill="#007EA0"/></svg></span>
              <span *ngSwitchCase="3"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V1.33333C12 0.6 11.4 0 10.6667 0ZM10.6667 10.6667H1.33333V1.33333H10.6667V10.6667ZM9.99333 4L9.05333 3.05333L4.66 7.44667L2.94 5.73333L1.99333 6.67333L4.66 9.33333L9.99333 4Z" fill="#05803D"/></svg></span>
            </ng-container>
          </span>
        </div>

        <span class="status-text" [ngClass]="{ 'status-text--active': i <= visualStatusIndex }">
          {{ status }}
        </span>

        <span *ngIf="i < statuses.length - 1" class="status-line"></span>
      </div>

    </div>
  </ng-template>

</div>

          </div>
        </section>
      </section>

      <footer class="wizard-footer button-container">
        <button class="btn btn-rechazado" (click)="rejectTruckLocal()">
          <i class="bi bi-slash-circle block-icon"></i>Camión rechazado
        </button>

<button
  *ngIf="currentStep === 1"
  type="button"
  class="btn btn-primary"
  (click)="continueAridoStep1()"
  [disabled]="isContinuing || !canContinue"
>
  Continuar
</button>

      </footer>
    </section>

    <section *ngIf="currentStep === 2" class="wizard-step-content">
      <form>
        <div class="form-container-grid">
          <div class="full">
            <label>Observaciones guía</label>
            <textarea
              placeholder="Ingresa tu comentario"
              class="form-control"
              rows="5"
              [formControl]="form.controls.guidingRemarks">
            </textarea>
          </div>

          <div class="full">
            <label>Motivo retorno</label>
            <select class="form-control" [formControl]="form.controls.reasonToReturn">
              <option disabled value="">Seleccionar</option>
              <option *ngFor="let r of returnReasons" [value]="r">{{ r }}</option>
            </select>
          </div>
        </div>
      </form>
    </section>

    <footer class="wizard-footer button-container">
      <button *ngIf="currentStep === 2" type="button" class="btn-ghost" (click)="prevStepArido()"> Atrás </button>

      <button class="btn btn-rechazado" (click)="rejectTruckLocal()" *ngIf="currentStep === 2">
        <i class="bi bi-slash-circle block-icon"></i>Camión rechazado
      </button>

      <button class="btn btn-primary" (click)="confirm()" *ngIf="currentStep === 2">Finalizar</button>
    </footer>

  </div>
</div>

<ng-template #modalContent>
  <div class="modal-container">
    <button class="close_button" (click)="closeModal()">×</button>

    <i class="bi bi-exclamation-triangle-fill modal-warning-icon"></i>

    <h2 class="modal-title">Confirmar datos</h2>

    <p class="modal-text">
      Al realizar esta acción, después no podrás cambiar la información.
    </p>

    <div class="modal_footer">
      <div class="buttons" style="width: 47.5%; margin-right: auto;">
        <a class="btn back-button" (click)="closeModal()">Seguir editando</a>
      </div>

      <div class="buttons" style="width: 47.5%;">
        <a class="btn btn-primary btn-back " (click)="submit()">Confirmar</a>
      </div>
    </div>
  </div>
</ng-template>

